export class InnerError extends Error {
  constructor(message) {
    super(message);
    this.name = 'Inner Error';
  }
}
